import Header from 'react-scale/components/elements/header';
import FormContent from 'react-scale/components/pages/sales/step-form/form-content';
import Image from 'next/image';
import { themeMixed } from 'react-scale/components/elements/header/header-themes';

const Demo = () => (
  <div className="overflow-hidden">
    <Image
      src="/static/images/pages/sales/bg.png"
      alt="background"
      quality={100}
      width={2880}
      height={2122}
      className="absolute inset-0 hidden object-cover w-full pointer-events-none select-none md:block"
      priority
    />
    <Image
      src="/static/images/pages/sales/bg-mobile.png"
      alt="background"
      quality={100}
      width={750}
      height={2410}
      className="absolute inset-0 pointer-events-none select-none md:hidden"
      priority
    />
    <div className="relative z-10 text-white">
      {/* @ts-ignore */}
      <Header
        title="Request a Demo | Scale AI"
        description="Get in touch with the Scale AI team! Fill out the contact us form we'll be in contact."
        canonical="https://scale.com/sales"
        ogImg="https://scale.com/static/img/website/sales/facebook.png"
        theme={themeMixed}
      />
      <FormContent />
    </div>
  </div>
);

export default Demo;
